import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

/**
 * Design-system chip color cycle: primary → teal → grey → primary-dark.
 * Mirrors the ngo-chip / --teal / --grey / --dark variants from the design tokens.
 */
const CHIP_VARIANTS: SystemStyleObject<Theme>[] = [
  { bgcolor: 'primary.main', color: 'common.white', '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.8)' } },
  { bgcolor: 'secondary.main', color: 'common.white', '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.8)' } },
  { bgcolor: 'grey.100', color: 'text.primary' },
  { bgcolor: 'primary.dark', color: 'common.white', '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.8)' } },
];

export const getTagChipSx = (index: number): SystemStyleObject<Theme> => CHIP_VARIANTS[index % CHIP_VARIANTS.length];

/** Tiny chip used on list rows and source cards (ngo-chip--sm). */
export const smallTagChipSx = (index: number): SystemStyleObject<Theme> => ({
  height: 16,
  fontSize: 10,
  fontWeight: 500,
  borderRadius: '2px',
  '& .MuiChip-label': { px: 0.5 },
  ...CHIP_VARIANTS[index % CHIP_VARIANTS.length],
});
